// DownloadFullDataButton.js
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  outputValue,
  outputIncludeNonValidated,
  outputIncludeOutboundBeacons,
} from '../../redux/validation/validationResultsSlice';
import { Button, Box } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import SaveIcon from '@mui/icons-material/Save';
import { handleDownloadFullData } from '../../utilities/export/handleDownloadFullData';
import { handleDownloadExcel } from '../../utilities/export/handleDownloadExcel';
import { handleDownloadPDF } from '../../utilities/export/handleDownloadPDF';
import ExportOptionsDialog from './ExportOptionsDialog';
import SaveResultsDialog from '../validation/SaveResultsDialog';

export default function DownloadFullDataButton() {
  const apiReturn = useSelector(outputValue);
  const includeNonValidated = useSelector(outputIncludeNonValidated);
  const includeOutboundBeacons = useSelector(outputIncludeOutboundBeacons);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [saveDialogOpen, setSaveDialogOpen] = useState(false);

  // Manually sort the API return data by timestamp
  const sortedApiReturn = [...apiReturn].sort((a, b) => a.timestamp - b.timestamp);

  // Only display the button if there is data
  if (sortedApiReturn.length === 0) return <Box />;

  const handleExport = async (options) => {
    if (options.format === 'excel') {
      await handleDownloadExcel(
        sortedApiReturn,
        options.includeNonValidated,
        options.includeOutbound,
        options.regressionTag,
      );
    } else if (options.format === 'pdf') {
      handleDownloadPDF(
        sortedApiReturn,
        options.includeNonValidated,
        options.includeOutbound,
        options.regressionTag,
      );
    } else {
      handleDownloadFullData(sortedApiReturn, options.includeNonValidated, options.regressionTag);
    }
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'flex-end',
          gap: 2,
          mb: 2,
          ml: 2,
        }}
      >
        {/* Save Results Button */}
        <Button
          variant="contained"
          startIcon={<SaveIcon />}
          sx={{
            bgcolor: 'success.main',
            color: 'background.paper',
            fontWeight: 'bold',
            borderRadius: 2,
            textTransform: 'none',
            '&:hover': { bgcolor: 'success.main' },
          }}
          onClick={() => setSaveDialogOpen(true)}
        >
          Save Results
        </Button>
        <Button
          variant="contained"
          endIcon={<DownloadIcon />}
          sx={{
            bgcolor: 'primary.main',
            color: 'background.paper',
            fontWeight: 'bold',
            borderRadius: 2,
            textTransform: 'none',
            '&:hover': { bgcolor: 'primary.light' },
          }}
          onClick={() => setDialogOpen(true)}
        >
          Download Data
        </Button>
      </Box>

      <ExportOptionsDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        onExport={handleExport}
        currentFilters={{
          includeOutbound: includeOutboundBeacons,
          includeNonValidated: includeNonValidated,
        }}
      />

      <SaveResultsDialog
        open={saveDialogOpen}
        onClose={() => setSaveDialogOpen(false)}
        testData={apiReturn}
      />
    </>
  );
}
